import BasePaymentMethod from './BasePaymentMethod';
import paymentApi from '../paymentApi';
import {EPaymentType} from "../../../@types/payrix";
import Contact from "@/entities/contact";

export function formatName(given_name: string, surname: string): string {
    return `${given_name || ''} ${surname || ''}`.trim();
}

class PaymentBankAccount extends BasePaymentMethod {
    constructor(props: any) {
        super(EPaymentType.Bank);

        // Check props for Payrix-only field
        if (paymentApi.isPayrix()) {
            this.fromPayrix(props);
        }
        else {
            this.fromLawpay(props);
        }
    }

    clone() {
        // Use spread operator to copy all properties, avoiding structuredClone issues
        const cl = new PaymentBankAccount({...this});
        cl.contact = this.contact ? new Contact(this.contact) : undefined;
        return cl;
    }
}

export default PaymentBankAccount;
